import { render, staticRenderFns } from "./DataAnalysis.vue?vue&type=template&id=04170025&scoped=true"
import script from "./DataAnalysis.vue?vue&type=script&lang=js"
export * from "./DataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./DataAnalysis.vue?vue&type=style&index=0&id=04170025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04170025",
  null
  
)

export default component.exports